var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStandaddtitle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 5,
    width: 30,
    height: 22,
    rx: 2,
    stroke: "#151514",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.35414 23L8.12532 20.7197H11.8747L12.6459 23H15L11.4181 13H8.58701L5 23H7.35414ZM8.68341 19.0693L9.96195 15.2852H10.0431L11.3217 19.0693H8.68341Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2255 23C18.216 23 18.8575 22.5628 19.1847 21.9312H19.2371V22.8719H21V18.2965C21 16.6801 19.6473 16 18.1549 16C16.5491 16 15.4931 16.7773 15.2356 18.0139L16.9549 18.1552C17.0815 17.7047 17.4785 17.3735 18.1462 17.3735C18.7789 17.3735 19.1411 17.6959 19.1411 18.2524V18.2789C19.1411 18.7161 18.6829 18.7735 17.5178 18.8883C16.1913 19.012 15 19.4625 15 20.9773C15 22.3199 15.9469 23 17.2255 23ZM17.7578 21.7016C17.1862 21.7016 16.776 21.4322 16.776 20.9155C16.776 20.3855 17.208 20.1249 17.8625 20.0322C18.2684 19.9748 18.9316 19.8776 19.1542 19.7274V20.4473C19.1542 21.1584 18.5738 21.7016 17.7578 21.7016Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStandaddtitle);
export default __webpack_public_path__ + "static/media/standaddtitle.7cdce4ea.svg";
export { ForwardRef as ReactComponent };var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStandaddtitle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 5,
    width: 30,
    height: 22,
    rx: 2,
    stroke: "#151514",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.35414 23L8.12532 20.7197H11.8747L12.6459 23H15L11.4181 13H8.58701L5 23H7.35414ZM8.68341 19.0693L9.96195 15.2852H10.0431L11.3217 19.0693H8.68341Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2255 23C18.216 23 18.8575 22.5628 19.1847 21.9312H19.2371V22.8719H21V18.2965C21 16.6801 19.6473 16 18.1549 16C16.5491 16 15.4931 16.7773 15.2356 18.0139L16.9549 18.1552C17.0815 17.7047 17.4785 17.3735 18.1462 17.3735C18.7789 17.3735 19.1411 17.6959 19.1411 18.2524V18.2789C19.1411 18.7161 18.6829 18.7735 17.5178 18.8883C16.1913 19.012 15 19.4625 15 20.9773C15 22.3199 15.9469 23 17.2255 23ZM17.7578 21.7016C17.1862 21.7016 16.776 21.4322 16.776 20.9155C16.776 20.3855 17.208 20.1249 17.8625 20.0322C18.2684 19.9748 18.9316 19.8776 19.1542 19.7274V20.4473C19.1542 21.1584 18.5738 21.7016 17.7578 21.7016Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStandaddtitle);
export default __webpack_public_path__ + "static/media/standaddtitle.7cdce4ea.svg";
export { ForwardRef as ReactComponent };